var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRect6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_1757_26074)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.0456,
    height: 96.0456,
    transform: "matrix(-0.684537 -0.728978 -0.728978 0.684537 146.565 72.0156)",
    fill: "url(#paint0_linear_1757_26074)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_1757_26074",
    x: 0.174395,
    y: 0.671396,
    width: 157.019,
    height: 157.02,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5.31441,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1757_26074"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.30022
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.97162
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0578512 0 0 0 0 0.106446 0 0 0 0 0.222149 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1757_26074"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1757_26074",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.664302,
    result: "effect2_foregroundBlur_1757_26074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1757_26074",
    x1: 83.8998,
    y1: 82.3115,
    x2: 10.4641,
    y2: 19.4334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D378B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6DC0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRect6);
export default __webpack_public_path__ + "static/media/rect6.f7646f1ffd114e3d4cf1528c18e177f4.svg";
export { ForwardRef as ReactComponent };